import React, { useState } from 'react';

import { Input, PasswordToggleButton } from 'components/core';
import styles from './PasswordInput.module.css';

export interface PasswordInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  title?: string;
  showTitle?: boolean;
  showOptTxt?: boolean;
  showDescription?: boolean;
  error?: string;
}

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, error, ...rest }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <>
        <div className={`position-relative ${styles.wrapper}`}>
          <Input
            ref={ref}
            autoComplete="current-password"
            {...rest}
            type={visible ? 'text' : 'password'}
            className={[styles.password_input, error ? 'is-invalid' : '', className]
              .filter(Boolean)
              .join(' ')}
          />
          <PasswordToggleButton
            visible={visible}
            onToggle={() => setVisible((prev) => !prev)}
            className={styles.toggle_button}
            disabled={rest.disabled}
          />
        </div>
        {error && <div className="invalid-feedback d-block">{error}</div>}
      </>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';
